module.exports = __webpack_public_path__ + "static/img/Rgh-Operation-Vote.cb12fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/Rgh-Operation-Vote.jpg
// module id = imO4
// module chunks = 1